import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedComponentsRoutingModule } from './shared-components-routing.module';
import { ToastMessageComponent } from './toast-message/toast-message.component';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { CardModule } from 'primeng/card';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { InplaceModule } from 'primeng/inplace';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TimelineModule } from 'primeng/timeline';
import { PaginatorModule } from 'primeng/paginator';
import { ESignDetailsComponent } from './e-sign-details/e-sign-details.component';
import { EstampDetailsComponent } from './estamp-details/estamp-details.component';
import { OrderConfirmationDetailsComponent } from './order-confirmation-details/order-confirmation-details.component';
import { TabViewModule } from 'primeng/tabview';
import { DrawerModule } from 'primeng/drawer';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropComponent } from './drag-drop/drag-drop.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SelectBranchComponent } from './select-branch/select-branch.component';
import { SafeUrlPipe } from './safe-url.pipi';
import { Textarea } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ReviewOrderDetailsComponent } from './review-order-details/review-order-details.component';
import { AccordionModule } from 'primeng/accordion';
import { ArticleCodeListComponent } from './article-code-list/article-code-list.component';
import { NumberToWordsWithCurrencyPipe } from './numberToWords';
import { PaymentOrderComponent } from './payment-order/payment-order.component';
import { GoogleDriveModalComponent } from './google-drive-modal/google-drive-modal.component';
import { DropboxModalComponent } from './dropbox-modal/dropbox-modal.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { OneDriveModalComponent } from './onedrive-modal/onedrive-modal.component';
import { UploadLinkComponent } from './upload-link/upload-link.component';
import { PdfEditorComponent } from './pdf-editor/pdf-editor.component';
import { AppButtonComponent } from './app-button/app-button.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { DataTableComponent } from './data-table/data-table.component';
import { AppColumnChooserComponent } from './data-table/column-chooser.component';
import { AppTableCellDirective } from './data-table/table-cell.directive';
import { RowActionStopDirective } from './data-table/row-action-stop.directive';
import { AppTableFooterDirective } from './data-table/table-footer.directive';
import { AppIconActionDirective } from './data-table/icon-action.directive';
import { FormFieldComponent } from './form-field/form-field.component';
import { AppConfirmDialogComponent } from './app-confirm-dialog/app-confirm-dialog.component';
import { AppDropdownComponent } from './app-dropdown/app-dropdown.component';
import { AppMultiselectDropdownComponent } from './app-multiselect-dropdown/app-multiselect-dropdown.component';
import { AppInputTextComponent } from './app-input-text/app-input-text.component';
import { AppSearchInputComponent } from './app-search-input/app-search-input.component';
import { TablePaginationComponent } from './table-pagination/table-pagination.component';
import { AppTabViewComponent } from './app-tab-view/app-tab-view.component';
import { TrackClickDirective } from '../directives/track-click.directive';
import { PdfVirtualViewerComponent } from './pdf-virtual-viewer/pdf-virtual-viewer.component';
import { DocumentPreviewModalComponent } from './document-preview-modal/document-preview-modal.component';

@NgModule({
  declarations: [
    ToastMessageComponent,
    ESignDetailsComponent,
    EstampDetailsComponent,
    OrderConfirmationDetailsComponent,
    DragDropComponent,
    SelectBranchComponent,
    SafeUrlPipe,
    ReviewOrderDetailsComponent,
    ArticleCodeListComponent,
    NumberToWordsWithCurrencyPipe,
    PaymentOrderComponent,
    GoogleDriveModalComponent,
    DropboxModalComponent,
    OneDriveModalComponent,
    UploadLinkComponent,
    PdfEditorComponent,
    AppButtonComponent,
    StatusBadgeComponent,
    PageHeaderComponent,
    DataTableComponent,
    AppColumnChooserComponent,
    AppTableCellDirective,
    RowActionStopDirective,
    AppTableFooterDirective,
    AppIconActionDirective,
    FormFieldComponent,
    AppConfirmDialogComponent,
    AppDropdownComponent,
    AppMultiselectDropdownComponent,
    AppInputTextComponent,
    AppSearchInputComponent,
    TablePaginationComponent,
    TrackClickDirective,
    AppTabViewComponent,
    PdfVirtualViewerComponent,
    DocumentPreviewModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsRoutingModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    ToastModule,
    MenubarModule,
    BadgeModule,
    AvatarModule,
    CardModule,
    ScrollPanelModule,
    AutoCompleteModule,
    DatePickerModule,
    SelectModule,
    FormsModule,
    StepsModule,
    InputTextModule,
    TableModule,
    ToggleSwitchModule,
    ConfirmPopupModule,
    InplaceModule,
    InputTextModule,
    RadioButtonModule,
    TimelineModule,
    PaginatorModule,
    TabViewModule,
    DrawerModule,
    SplitButtonModule,
    TooltipModule,
    MultiSelectModule,
    NgbModule,
    DragDropModule,
    PdfViewerModule,
    Textarea,
    ConfirmDialogModule,
    AccordionModule,
    ProgressSpinnerModule,
    DialogModule
  ],
  exports: [
    ESignDetailsComponent,
    EstampDetailsComponent,
    OrderConfirmationDetailsComponent,
    DragDropComponent,
    SelectBranchComponent,
    ReviewOrderDetailsComponent,
    ArticleCodeListComponent,
    PaymentOrderComponent,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    ToastModule,
    MenubarModule,
    BadgeModule,
    AvatarModule,
    CardModule,
    ScrollPanelModule,
    AutoCompleteModule,
    DatePickerModule,
    SelectModule,
    StepsModule,
    InputTextModule,
    TableModule,
    ToggleSwitchModule,
    ConfirmPopupModule,
    InplaceModule,
    InputTextModule,
    RadioButtonModule,
    TimelineModule,
    PaginatorModule,
    TabViewModule,
    DrawerModule,
    SplitButtonModule,
    TooltipModule,
    MultiSelectModule,
    NgbModule,
    DragDropModule,
    PdfViewerModule,
    SafeUrlPipe,
    NumberToWordsWithCurrencyPipe,
    Textarea,
    ConfirmDialogModule,
    AccordionModule,
    GoogleDriveModalComponent,
    DropboxModalComponent,
    ProgressSpinnerModule,
    DialogModule,
    OneDriveModalComponent,
    UploadLinkComponent,
    PdfEditorComponent,
    AppButtonComponent,
    StatusBadgeComponent,
    PageHeaderComponent,
    DataTableComponent,
    AppColumnChooserComponent,
    AppTableCellDirective,
    RowActionStopDirective,
    AppTableFooterDirective,
    AppIconActionDirective,
    FormFieldComponent,
    AppConfirmDialogComponent,
    AppDropdownComponent,
    AppMultiselectDropdownComponent,
    AppInputTextComponent,
    AppSearchInputComponent,
    TablePaginationComponent,
     TrackClickDirective,
    AppTabViewComponent,
    PdfVirtualViewerComponent,
    DocumentPreviewModalComponent
  ],
  providers: [MessageService, ConfirmationService]
})
export class SharedComponentsModule { }
